import axios from "axios";
import { Base_Url, Api_MqTh } from "./apiUrl";

export const AXIOS_CLIENT = axios.create({
    baseURL: Base_Url + Api_MqTh,
    headers: {
        "Content-Type": "application/json",
        "Content-Type": "application/x-www-form-urlencoded"
    },
});